module.exports = __webpack_public_path__ + "static/media/backgroundImage.c7d891f3.svg";